import { USER_ROLES } from "./constant";

/**
 * When a company user creates a call centre, the default login must be Call Centre Admin only.
 */
export function filterDefaultCallCentreUserRoles(roleOptions, creatorRole) {
  if (!Array.isArray(roleOptions) || !roleOptions.length) {
    return [];
  }
  if (creatorRole === USER_ROLES.COMPANY_ADMIN) {
    return roleOptions.filter((opt) => opt.value === USER_ROLES.CALL_CENTRE_ADMIN);
  }
  return roleOptions;
}

export function isCompanyUserCreatingCallCentre(creatorRole) {
  return creatorRole === USER_ROLES.COMPANY_ADMIN;
}
